import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //注册
  reg(params) {
    return axios.post(`${base.bs}/gsyf/reg/index`,params)
  },
  //肚子点
  ajaxDicListByPcode(params) {
    return axios.get(`${base.bs}/gsyf/reg/getListByPcode`,{params:params})
  },
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/gsyf/gsyfOrgan/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/get/${params.id}`)
  },//根据id查询单个信息
  getByUid(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/getByUid/${params.id}`)
  },
  //本人单位嘻嘻
  getMy(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/getMy`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/gsyf/gsyfOrgan/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/batchDel`,{params:params})
  },
  //批量删除
  repwd(params) {
    return axios.get(`${base.bs}/admin/gsyf/gsyfOrgan/repwd/${params.id}`,null)
  },
  //保存修改
  myset(params) {
    return axios.post(`${base.bs}/admin/gsyf/gsyfOrgan/myset`, params)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/gsyfOrgan.js